/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React from 'react';

// ours
import { DateInput, FieldControl, Label, MonthInput, YearInput } from '@americanexpress/dls-react';

// styles
import styles from './DatePicker.module.scss';
import FormatService from '../../services/format.service';
import { LocalDate } from '@js-joda/core';

interface DatePickerProps {
    label: string;
    id: string;
    minDate?: string;
    maxDate?: string;
    value: string;
    onChange: (date: any) => Promise<void>;
    'data-cy'?: string;
}

export default function DatePicker({
    label,
    id,
    minDate,
    maxDate,
    value,
    onChange,
    ...props
}: DatePickerProps): JSX.Element {
    return (
        <FieldControl className={styles.datePickerContainer} status="" {...props}>
            <Label htmlFor={id} className={styles.pickerLabel}>
                {label}
            </Label>
            <DateInput
                className={styles.pickerComponent}
                id={id}
                minDate={minDate || FormatService.formatSqlDate(LocalDate.now().minusYears(100))}
                maxDate={maxDate || FormatService.formatSqlDate(LocalDate.now().plusYears(100))}
                value={value}
                onChange={onChange}
                status=""
            >
                <MonthInput className={styles.monthInput} />
                <YearInput className={styles.yearInput} />
            </DateInput>
        </FieldControl>
    );
}
